export default "__VITE_ASSET__CbB9yKHM__ 374w";